import styled from 'styled-components';

export const StyledDataHeaderElement = styled.div`
    width: ${({ $hasDeclaredWidth }) => ($hasDeclaredWidth ? $hasDeclaredWidth : '16%')};
    padding: 0 4px;
`;
